import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vel-toolbar bg-blue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")!

  return (_openBlock(), _createBlock(_component_vue_easy_lightbox, {
    imgs: _ctx.images,
    index: _ctx.index,
    visible: _ctx.zooming,
    onHide: _cache[0] || (_cache[0] = () => _ctx.zooming = !_ctx.zooming)
  }, {
    toolbar: _withCtx(({ toolbarMethods }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          color: "blue",
          onClick: toolbarMethods.zoomIn
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: "images/zoom-in.png",
              class: "q-pa-sm",
              style: {"width":"25px"}
            }, null, -1)
          ])),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_v_btn, {
          color: "blue",
          onClick: toolbarMethods.zoomOut
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: "images/zoom-out.png",
              class: "q-pa-sm",
              style: {"width":"25px"}
            }, null, -1)
          ])),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["imgs", "index", "visible"]))
}